import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("alekas_cart") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("alekas_cart", JSON.stringify(items)); }, [items]);
  const add = (product_id, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product_id);
      if (idx >= 0) {
        const copy = [...prev]; copy[idx].quantity += qty; return copy;
      }
      return [...prev, { product_id, quantity: qty }];
    });
    toast.success("Added to cart");
  };
  const setQty = (id, q) => setItems((p) => p.map((i) => i.product_id === id ? { ...i, quantity: Math.max(1, q) } : i));
  const remove = (id) => setItems((p) => p.filter((i) => i.product_id !== id));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  return <CartCtx.Provider value={{ items, add, setQty, remove, clear, count }}>{children}</CartCtx.Provider>;
}
